import { render, staticRenderFns } from "./ProfileMyProfileEditPhoneModal.vue?vue&type=template&id=3995f60e&scoped=true&"
import script from "./ProfileMyProfileEditPhoneModal.vue?vue&type=script&lang=ts&"
export * from "./ProfileMyProfileEditPhoneModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3995f60e",
  null
  
)

export default component.exports